import { useMutation } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';

export const useDeleteRelatedPassenger = () => {
  const { doFetch: deleteRelatedPassenger } = useFetch<unknown, void>();

  return useMutation<void, ErrorResponse<unknown>, number>({
    mutationFn: (passengerId: number) => deleteRelatedPassenger(`/api/clients/${passengerId}`, { method: 'DELETE' }),
  });
};
